var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29289 5.63275C7.90237 5.25924 7.90237 4.65365 8.29289 4.28014C8.68342 3.90662 9.31658 3.90662 9.70711 4.28014L15.7071 11.2687C16.0976 11.6422 16.0976 12.2478 15.7071 12.6213L9.70711 19.7199C9.31658 20.0934 8.68342 20.0934 8.29289 19.7199C7.90237 19.3463 7.90237 18.7408 8.29289 18.3672L13.5858 11.945L8.29289 5.63275Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight1);
export default __webpack_public_path__ + "static/media/chevron-right-1.4cb1d533cbf6143de39a568b7947cbcc.svg";
export { ForwardRef as ReactComponent };